import React from 'react';
export function Footer() {
  return <footer className="w-full bg-navy px-5 py-10" data-id="element-77" data-mp="32wmqrybuniwl">
      <div className="mx-auto max-w-2xl text-center" data-id="element-78" data-mp="3gfsn6dua2wni">
        <p className="font-display text-base font-semibold text-gold" data-id="element-79" data-mp="3ggkal1dq1o2p">The ESL Survival Vault™</p>
        <p className="mt-2 text-xs leading-relaxed text-white/60" data-id="element-80" data-mp="32pp5m06cfr4e">
          Premium digital teaching system for ESL &amp; EFL professionals worldwide. Instant download
          · One-time payment · 14-day guarantee.
        </p>
        <p className="mt-4 text-xs text-white/40" data-id="element-81" data-mp="38qz78i6g9vx">© 2026 EduVault Press. All Rights Reserved.</p>
      </div>
    </footer>;
}